<script setup>

import ContactForm from "@/Components/ContactForm.vue";
import AsharaFeatures from "@/Components/Landing/AsharaFeatures.vue";
import TimeLine from "@/Components/Landing/TimeLine.vue";
import Clients from "@/Components/Landing/Clients.vue";
import HomeAboutUs from "@/Components/Landing/HomeAboutUs.vue";
import WhyAshara from "@/Components/Landing/WhyAshara.vue";
import TrustedBy from "@/Components/Landing/TrustedBy.vue";
import { useDisplay } from "vuetify";
import { ref, inject } from "vue";
import { router } from "@inertiajs/vue3";
import { useThemeSetting } from '@/Composable/ThemeSetting';
import { onMounted, onUnmounted } from 'vue';
const { isDark } = useThemeSetting();
const { mdAndUp, lgAndUp, smAndDown } = useDisplay();
const __t = inject("__t");
const props = defineProps({
    fromHome: {
        type: Boolean,
        default: false
    }
});

</script>

<template>

    <Head title="التدريب التفاعلي" />

    <Head>
        <meta head-key="description" name="description" content="اكتشف مستقبل التدريب الإلكتروني مع منصة عشرة. نقدم حلولاً تفاعلية مبتكرة تجمع بين التكنولوجيا المتقدمة والتعليم الفعال. انضم إلينا لتحويل دوراتك التدريبية إلى تجربة تعليمية استثنائية." />
    </Head>

    <v-container class="px-md-12">
        <div class=" px-md-5 mb-5">




            <div class=" rounded-3xl mt-9 mt-md-4 relative bg-top bg-no-repeat bg-cover"
                :style="!props.fromHome ? 'background-image: url(\'/assets/patterns/pattern.webp\')' : ''"
                data-aos="fade-up">
                <div
                    class="h-full w-full  bg-no-repeat bg-center bg-origin-padding bg-cover rounded-3xl">
                    <div class="h-full w-full min-h-60  my-auto backdrop-blur-[px] bg-base/9 0 rounded-3xl border-solid  "
                        :class="!props.fromHome ? 'border dark:bg-black/50 ' : ''">
                        <v-row class="flex ">
                            <v-col cols="12" md="5"
                                class="flex items-center justify-center rtl:pr-md-12 ltr:pl-md-12 py-0  ">
                                <img preload alt="3kode" :src="isDark ? '/assets/c-interactive-training.svg' : '/assets/c-interactive-training.svg'"
                                    class=" mt-9 transform transition-all duration-700 max-h-[30 0px]  w-full md:scale-110"></img>
                            </v-col>
                            <v-col cols="12" md="7" class="flex items-center justify-center">
                                <div class="flex flex-col px-6 mb-5 text-center px-md-6 text-md-start ">


                                    <h1 class="text-2xl leading-10 mb-5 mt-8 " data-aos="fade-up">
                                        التدريب التفاعلي
                                    </h1>
                                    <h2
                                        class="text-3xl font-bold lg:text-4xl leading-10 lg:leading-[60px] text-black dark:text-white">

                                        حقبة جديدة من التدريب والتعليم الالكتروني مع منصة عشرة
                                        <span class="text-primary font-bold mt-2">بإدوات تفاعلية مبتكرة</span>
                                    </h2>
                                    <p class="mt-3 text-lg leading-10">
                                        تفاعل مباشر ومخصص امنح متدربيك تجربة استثنائية عبر أدوات تفاعلية مبتكرة.

                                    </p>
                                    <v-btn class="mt-3" variant="flat" color="primary" v-if="props.fromHome"
                                        @click="router.visit(route('contact'))">
                                        تعرف على المزيد
                                    </v-btn>
                                    <div class="flex justify-center justify-md-start w-full" v-else>

                                        <v-btn class="mt-3 px-10 mb-9" variant="flat" color="primary"
                                            @click="router.visit(route('contact'))">
                                            ابدأ معنا الآن
                                        </v-btn>
                                    </div>

                                </div>
                            </v-col>

                        </v-row>
                    </div>

                </div>
            </div>
            <div class="mt-5 px-4 px-md-5">
                <v-row class="scale-on-scroll transition-all duration-500 flex flex-wrap justify-center">
                    <v-col cols="12" md="12" class="mt-24 text-center px-md-9">
                        <div class=" rtl:pr-md-9 ltr:pl-md-9 flex  items-center justify-center gap-4">
                            <img src="/assets/ar10.svg" class=" h-[40px] mb-4" alt="Ashara Logo">
                            <h2
                                class="items-baseline justify-center block mt-3 mb-4 text-3xl  text-black md:text-4xl mt-md-0 md:flex dark:text-white">
                                <!-- {{ __t('start_your_training_journey_today') }} -->
                                "اهلا بحقبة جديدة من التدريب والتعليم الالكتروني التفاعلي مع منصة عشرة"

                            </h2>
                            <img src="/assets/ar10.svg" class="h-[40px] mb-4  rotate-180 " alt="Ashara Logo">


                        </div>

                    </v-col>
                    <v-col cols="12" md="12" class="mb-12 text-center px-md-9">
                        <div class=" rtl:pr-md-9 ltr:pl-md-9 flex  items-center justify-center gap-4">

                            <p class="items-baseline justify-center block mt-3 mb-4  md:w-2/3 leading-10
                             text-secondary md:text-lg mt-md-0 md:flex dark:text-white">
                                <!-- {{ __t('start_your_training_journey_today') }} -->

                               ركز فقط على محتواتك التعليمي واترك الباقي لنا ,
                               نوفر لك الوسائل التفاعلية المبتكرة لتحقيق اقصى استفادة من من الخبرات والمحتوى التعليمي



                            </p>


                        </div>

                    </v-col>

                    <div class="w-full group transition-all duration-500 flex flex-wrap justify-center border rounded-xl p-4 bg-white dark:bg-black ">
                        <div class="relative w-full ">
                            <div
                                class="absolute top-24 right-24  w-[200px] h-[300px] md:w-[500px] md:h-[300px] rounded-full bg-primary/10 md:bg-primary/20 dark:bg-primary/90 blur-[100px] animate-[pulse_3s_ease-in-out_infinite] -z-0">
                            </div>
                            <div
                                class="absolute  top-24  left-24 w-[200px] h-[300px] md:w-[500px] md:h-[300px] rounded-full bg-primary/10 md:bg-primary/30 dark:bg-primary/30 blur-[100px] animate-[pulse_2s_ease-in-out_infinite] -z-0">
                            </div>
                        </div>

                        <v-row class="flex flex-wrap justify-center z-10">
                            <v-col cols="12" md="6"
                                class="flex flex-col items-center justify-center text-center text-md-start">
                                <h1
                                    class="text-4xl w-full font-bold  leading-[60px] text-blac k dark:text-white mt-16 mt-md-0">
                                    خطة تدريبية ذكية <span class="text-primary font-bold">مختلفة لكل متدرب</span>
                                </h1>
                                <p class="w-full text-lg leading-10  mt-3 dark:text-white">
                                    اكتشف عالماً جديداً من التدريب الذكي! من خلال صفحة الترحيب بالمتدرب , سيتمكن النظام من فهم متدربيك  قبل بدء رحلتهم التعليمية. ويصمم جدول مخصص بمرونة تامة لتناسب أوقاتهم.  نمكنك من تصميم مسار تعليمي فريد يضمن نجاح كل متدرب في رحلته نحو التميز.
                                </p>
                            </v-col>
                            <v-col cols="12" md="5" class="flex items-center justify-center mt-16 mt-md-0">
                                <img src="/assets/c-onboarding.svg" alt="3kode"
                                    class="w-full scale-img -mt-12 group-hover:scale-110 transition-all duration-500 scale-110 md:scale-100">
                            </v-col>

                        </v-row>
                    </div>
                    <div class="w-full group transition-all duration-500 flex flex-wrap justify-center    rounded-xl p-4">
                        <v-row class="flex flex-wrap-reverse md:flex-wrap justify-center text-center text-md-start">
                            <v-col cols="12" md="5" class="flex items-center justify-center">
                                <img src="/assets/c-tasks.svg" alt="3kode"
                                    class="w-full -mt-12 group-hover:scale-110 transition-all duration-500 scale-110 md:scale-100">
                            </v-col>
                            <v-col cols="12" md="6" class="flex flex-col items-center justify-center px-md-9">
                                <h1
                                    class="text-4xl font-bold  leading-[60px] text-black dark:text-white mt-12 mt-md-0">
                                    مهام ديناميكية <span class="text-primary font-bold">تناسب قدرات كل متدرب</span>
                                </h1>
                                <p class="w-full text-lg leading-10  mt-3 mb-16 md:mb-0">
                                    بناءً على تقييم مستوى المتدرب في صفحة الترحيب، يقوم النظام بتخصيص مهام يومية ذكية تتناسب مع قدراته وأهدافه. مع جدول زمني مرن يمكن تعديله، ومساعد ذكي يوجه المتدرب، ونظام متابعة يضمن إنجاز المهام في وقتها المحدد. كل هذا يجعل رحلة التعلم أكثر فعالية وتشويقاً
                                </p>
                            </v-col>

                        </v-row>
                    </div>
                    <div class="w-full group transition-all duration-500 flex flex-wrap justify-center border rounded-xl p-4 bg-white dark:bg-black ">
                        <div class="relative w-full ">
                            <div
                                class="absolute top-24 right-24  w-[200px] h-[300px] md:w-[500px] md:h-[300px] rounded-full bg-primary/10 md:bg-primary/20 dark:bg-primary/90 blur-[100px] animate-[pulse_3s_ease-in-out_infinite] -z-0">
                            </div>
                            <div
                                class="absolute  top-24  left-24 w-[200px] h-[300px] md:w-[500px] md:h-[300px] rounded-full bg-primary/10 md:bg-primary/30 dark:bg-primary/30 blur-[100px] animate-[pulse_2s_ease-in-out_infinite] -z-0">
                            </div>
                        </div>

                        <v-row class="flex flex-wrap justify-center z-10">
                            <v-col cols="12" md="6"
                                class="flex flex-col items-center justify-center text-center text-md-start">
                                <h1
                                    class="text-4xl font-bold  w-full leading-[60px] text-black dark:text-white mt-16 mt-md-0">
                                    تفاعل ذكي مع <span class="text-primary font-bold">محتوى التدريب</span>
                                </h1>
                                <p class="w-full text-lg leading-10  mt-3 mb-16 md:mb-0 dark:text-white">
                                    اضف ملاحظاتك على أي جزء من الفيديو لتظهر في الوقت المحدد، وأنشئ اختبارات تفاعلية تظهر خلال المحتوى لقياس فهم المتدربين. مع إمكانية مشاركة الملاحظات بين المتدربين وتفاعلهم مع المحتوى بشكل مباشر، مما يجعل تجربة التعلم أكثر تفاعلية وفعالية
                                </p>
                            
                            </v-col>
                            <v-col cols="12" md="5" class="flex items-center justify-center mt-16 mt-md-0">
                                <img src="/assets/c-player-note.svg" alt="3kode"
                                    class="w-full scale-img -mt-12 group-hover:scale-110 transition-all duration-500 scale-110 md:scale-100">
                            </v-col>

                        </v-row>
                    </div>
                    <div class="w-full group transition-all duration-500 flex flex-wrap justify-center    rounded-xl p-4">
                        <v-row class="flex flex-wrap-reverse md:flex-wrap justify-center text-center text-md-start">
                            <v-col cols="12" md="5" class="flex items-center justify-center">
                                <img src="/assets/c-quiz.svg" alt="3kode"
                                    class="w-full -mt-12 group-hover:scale-110 transition-all duration-500 scale-110 md:scale-100">
                            </v-col>
                            <v-col cols="12" md="6" class="flex flex-col items-center justify-center px-md-9">
                                <h1
                                    class="text-4xl font-bold w-full leading-[60px] text-black dark:text-white mt-12 mt-md-0">
                                    نظام اختبارات <span class="text-primary font-bold">تفاعلي متكامل</span>
                                </h1>
                                <p class="w-full text-lg leading-10  mt-3 mb-16 md:mb-0">
                                    نظام اختبارات متكامل يدعم جميع أنواع الأسئلة مع إمكانية تحديد الوقت وعرض النتائج فورياً. يمكنك إنشاء بنك أسئلة متنوع، وتوليد اختبارات عشوائية، مع تقارير تفصيلية عن أداء المتدربين ومستوى تقدمهم. كما يمكن للمتدرب تحديد الأسئلة التي تحتاج إلى مراجعة والحصول على تقرير مفصل عن أدائه في الاختبار. كل هذا مع واجهة سهلة الاستخدام تضمن تجربة سلسة للمدرب والمتدرب
                                </p>
                            </v-col>

                        </v-row>
                    </div>







           
         
                
           









                </v-row>

            </div>
            <div class="mt-16">
                <v-row>
                    <v-col cols="12" md="4">
                        <div class="relative group hover:animate-border inline-block rounded-lg p-[2px] h-full w-full">

                            <div
                                class="relative flex flex-col p-5 overflow-hidden text-start group-hover:opacity-100 
                                transition-all duration-200 h-full bg-black dark:bg-black dark:text-white w-full rounded-xl border-[1px] border-solid border-[#00000010] hover:scale-105">

                                <div
                                    class="absolute top-5 right-6 w-[200px] h-[200px] rounded-full bg-primary/50 dark:bg-primary/30 blur-[70px] animate-[pulse_3s_ease-in-out_infinite] -z-0">
                                </div>
                                <div
                                    class="absolute  top-12 left-6 w-[200px] h-[200px] rounded-full  bg-primary/50 dark:bg-primary/30 blur-[70px] animate-[pulse_2s_ease-in-out_infinite] -z-0">
                                </div>
                                <div class="w-full flex justify-end">
                                    <img src="/assets/svgicons/laptop-02.svg" alt="3kode" class=" invert h-12 w-12" />
                                </div>
                                <h2 class="text-lg font-bold text-white z-10">
                                    محتوى تفاعلي متنوع
                                </h2>
                                <p class=" opacity-70 text-start text-white mt-3 z-10">
                                    قدم محتوى تدريبي متنوع يشمل الفيديوهات التفاعلية والعروض التقديمية والملفات التعليمية المختلفة
                                </p>
                            </div>
                        </div>
                    </v-col>

                    <v-col cols="12" md="4">
                        <div class=" group rounded-lg p-[2px] h-full w-full">
                            <div
                                class=" relative flex flex-col p-5 text-start  group-hover:opacity-100 transition-all duration-200 h-full w-full
                                 bg-black dark:bg-black dark:text-white w-full rounded-xl overflow-hidden border-[1px] border-solid border-[#00000010] hover:scale-105">


                                <div
                                    class="absolute top-5 right-6 w-[200px] h-[200px] rounded-full bg-primary/50 dark:bg-primary/30 blur-[70px] animate-[pulse_3s_ease-in-out_infinite] -z-0">
                                </div>
                                <div
                                    class="absolute  top-12 left-6 w-[200px] h-[200px] rounded-full  bg-primary/50 dark:bg-primary/30 blur-[70px] animate-[pulse_2s_ease-in-out_infinite] -z-0">
                                </div>
                                <div class="w-full flex justify-end">
                                    <img src="/assets/svgicons/line-chart-up-01.svg" alt="3kode" class=" invert h-12 w-12" />
                                </div>

                                <h2 class="text-lg font-bold text-white z-10">
                                    تقييم مستمر للمتدربين
                                </h2>
                                <p class="opacity-70 text-start text-white mt-3 z-10">
                                    تابع تقدم المتدربين من خلال نظام تقييم شامل يتضمن الاختبارات والواجبات والمشاريع العملية
                                </p>
                            </div>
                        </div>
                    </v-col>

                    <v-col cols="12" md="4">
                        <div class=" group hover:animate-border  rounded-lg p-[2px] h-full w-full z-10">
                            <div
                                class=" relative flex flex-col p-5 text-start group-hover:opacity-100  transition-all duration-200 h-full 
                                bg-black dark:bg-black dark:text-white w-full rounded-xl overflow-hidden border-[1px] border-solid border-[#00000010] hover:scale-105">


                                <div
                                    class="absolute top-5 right-6 w-[200px] h-[200px] rounded-full bg-primary/50 dark:bg-primary/30 blur-[70px] animate-[pulse_3s_ease-in-out_infinite] z-0">
                                </div>
                                <div
                                    class="absolute  top-12 left-6 w-[200px] h-[200px] rounded-full  bg-primary/50 dark:bg-primary/30 blur-[70px] animate-[pulse_2s_ease-in-out_infinite] z-0">
                                </div>
                                <div class="w-full flex justify-end">
                                    <img src="/assets/svgicons/presentation-chart-01.svg" alt="3kode" class=" invert h-12 w-12" />
                                </div>

                                <h2 class="text-lg font-bold text-white z-10">
                                    تفاعل وتواصل مستمر
                                </h2>
                                <p class="opacity-70 text-start text-white mt-3 z-10">
                                    منتديات نقاش وغرف دردشة تتيح للمتدربين التواصل وتبادل الخبرات مع بعضهم البعض ومع المدربين
                                </p>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>


        </div>
    </v-container>

    <ContactForm />

    <AsharaFeatures :fromHome="false" hide="interactive-training"/>
    <TimeLine />
    <Clients />
    <HomeAboutUs />
    <WhyAshara />
    <TrustedBy />

</template>
